// ============================================================================
// src/regionsFonctions.js : la région de chaque fonction serveur appelée
// ============================================================================
// Chantier « lenteurs », étape 2 (10/10/2026 ; docs/exploitation/lenteurs-
// clic-2026-10-09.md). Les fonctions APPELABLES du module Événements tournent
// aussi à Francfort, à côté de la base (functions/evenements.js,
// REGIONS_APPELABLES) : l'écran les y appelle, soit 0,5 à 1 s de moins par
// clic. Toutes les autres restent en Iowa tant que leur module n'a pas basculé.
// Listes tenues À L'IDENTIQUE des fichiers serveur, et chaque appel de
// l'écran contrôlé, par src/regionsFonctions.test.js.
export const REGION_FRANCFORT = "europe-west3";
export const REGION_EVENEMENTS = REGION_FRANCFORT;

export const FONCTIONS_EVENEMENTS = new Set([
  "adminEventGenerateTokens", "adminEventListSenders", "adminEventPreviewAudience", "adminEventSetInviteRsvp",
  "adminEventSendInvitations", "adminEventSendLateCatchup", "adminEventSendMenuRequests", "adminEventRemerciement", "publicEventGetInvitation",
  "publicEventRsvp", "publicEventProposeUpdate", "publicEventChooseMenu", "publicEventProposePlus1",
  "publicEventOptOut", "publicEventOublierPreferences", "adminEventSubstituteInvite", "adminEventApproveUpdate",
  "adminEventRejectUpdate", "adminEventApprovePlus1", "adminEventRejectPlus1", "adminEventDedupPlus1",
  "publicEventGetTicket", "adminEventCheckIn", "adminEventWalkIn", "adminEventRsvpInboxValidate",
  "adminEventExportPresences", "adminEventSetMenuChoice", "adminEventExportMenus", "adminEventExportReponses",
  "adminEventDuplicate", "adminEventGenerateSlug", "adminEventSetTheme", "adminEventAssetUpload",
  "adminEventListAssets", "adminStorageDiag", "publicEventGetMicrosite", "publicEventRequestInvitation",
  "adminEventApproveInvitationRequest", "adminAnnotationCreate", "adminAnnotationDelete", "adminAnnotationList",
  "adminEventTableCreate", "adminEventTableUpdate", "adminEventTableDelete", "adminEventPlacementSet",
  "adminEventPlacementBatch", "adminEventAutoRepartition", "adminEventPlacementRuleCreate", "adminEventPlacementRuleDelete",
  "adminEventExportTablePlan", "adminEventEmailPreview", "getEnioOutlookContacts", "adminEventShareInternal",
  "adminEventAddPartner", "adminEventRevokePartner", "adminEventSetPartnerRole", "adminEventResendPartnerInvite",
  "partnerEventReviseContact", "adminEventNotifyPartnersRevision", "partnerEventGetDashboard", "adminEventPreviewPartnerDashboard",
  "partnerEventProposeAction", "partnerEventSearchContacts", "partnerPortalRequestLink", "partnerEventMatchInvitees",
  "partnerEventAddInvitees", "partnerEventTagInvitedBy", "coorgEventProposeInvitees", "coorgEventProposeAction",
  "adminEventResolveInviteProposal", "adminEventUpsert", "adminEventDelete", "adminEventAddInvites",
  "adminEventRemoveInvites", "adminEventImportComparer", "adminEventImportValider", "adminEventRepointContact", "adminEventSendSaveTheDate", "adminEventGetTimeline",
  "adminEventSetPartnerRecap", "adminEventPartnerRecapSend",
]);

// Lot 1 (11/10/2026) : graphProxy (functions/sharepoint.js), réunions et
// sondages (functions/reunions.js), courriels (functions/emails.js).
export const FONCTIONS_LOT1 = new Set([
  "graphProxy", "creerReunion", "reunionInvitationsEnvoi", "syncReunionRSVP", "reunionRafraichirTeams",
  "syncAllUpcomingReunionsRSVP", "linkReunionToThemis", "syncSondageDispoCalendrier", "notifierSondage",
  "calendrierDisponibilites", "envoyerOptionsSondage", "syncOptionSondageSlot", "notifierPropositionSondage",
  "confirmerSlotSondage", "syncSondageOutlookReponses", "relancerSondageNonRepondants", "envoyerDemandeRepresentation",
  "reunionRelancerInviteAbsent", "reunionAlerterDgPourDesignation", "reunionAdminDesignerRepresentant", "reunionRetirerDesAgendas",
  "sendEmail", "notifierQuestion", "notifierDemandeEngagement",
  "notifierReunion", "envoyerLienReinit", "validerTokenReinit", "signalerProblemeConnexion",
  "notifierDemandeCompte", "notifierValidationCompte", "notifierRefusCompte", "envoyerEmailPersonnalise",
  "renvoyerEmail", "listerEnvoisEmail", "envoyerInvitationAramis", "envoyerRelance2FA",
  "envoyerEmailGroupe", "notifierConsultation", "notifierSaisieDataviz", "notifierEngagementAthos",
  "themisEnvoyerConvocation", "themisPresenceContexte", "themisConfirmerPresence", "themisEnvoyerMessageSeance",
]);

// Lot 2 (11/10/2026) : séances et pages à jeton. Pouvoirs et émargement
// (functions/themisPouvoirs.js), repas (themisRepas.js), Agora (agora.js),
// PV (themisPV.js), réunion Outlook de séance (themisReunionSeance.js),
// relance des sans-réponse (themisRelancePresence.js).
export const FONCTIONS_LOT2 = new Set([
  "themisPouvoirContexte", "themisDonnerPouvoir", "themisRevoquerPouvoirParLien", "themisConfirmerPouvoir",
  "themisPouvoirParTiers", "themisRevoquerPouvoir", "themisPouvoirMarquerRecu", "themisAttribuerPouvoirBlanc",
  "themisPouvoirRelancerConfirmation", "themisPouvoirDemanderAuxAbsents", "themisPresenceSaisieEquipe", "themisEmargementEnvoyer",
  "themisEmargementAnnuler", "themisEmargementContexte", "themisEmargementSigner", "themisEmargementPreuves",
  "themisRepasInviter", "themisRepasContexte", "themisRepasRepondre", "themisRepasOublierPreferences",
  "themisRepasSaisieEquipe", "themisRepasSuivi", "themisRepasAgenda", "themisRedigerPV", "themisDerouleSeance",
  "themisReunionSeance", "themisRelancerSansReponse", "agoraVerifierCode", "agoraIdentifierParLien",
  "agoraLireCodes", "agoraEnregistrerCodes", "agoraLienVote", "agoraMigrerCodes",
]);

// Lot 3 (11/10/2026) : modules de travail. Veille juridique, gel et PPE,
// Noota et projets, dataviz et campagnes, réponses conjointes aux appels
// d'offres, cotisations, actualités des mutuelles, résidents d'index.js,
// Socrate.
export const FONCTIONS_LOT3 = new Set([
  "syntheseIA", "fusionnerDelegates", "migrerMutuelle", "adminThemisBibAdd",
  "adminThemisBibUpdate", "adminThemisBibDelete", "getGhaliaVideos", "gelPpeHealthcheck",
  "gelPpeListeVersions", "refreshGelPpeListesNow", "getGelPpeManifest", "gelPpeArchiverPdfTracfin",
  "gelPpeGetArchivePdfUrl", "gelPpeExportAgregeAcpr", "gelPpeConfirmerSoumissionTracfin", "migrateGelPpeAccents",
  "updateGelPpeHistoriqueStatut", "gelPpeAssignerAlerte", "gelPpeBulkUpdateStatut", "gelPpeCreateApiKey",
  "gelPpeRevokeApiKey", "adminAOReponseSave", "aoReponsePartager", "aoActeurExterneSave",
  "adminAOReponseDelete", "adminAOReponseExportXLSX", "adminAOReponseNotifier", "scrapeMutuelleNewsNow",
  "addMutuelleNewsItem", "deleteMutuelleNewsItem", "extractMutuelleNewsPdf", "syncMutuelleNewsSources",
  "scrapeVeilleJuridiqueNow", "syncVeilleJuridiqueSources", "activerSourceVeilleJuridique", "cleanupVeilleJuridiqueAnnonces",
  "getVeilleJuridiqueFilters", "updateVeilleJuridiqueFilters", "getJuridiquePreferences", "updateJuridiquePreferences",
  "refreshAcprRegistreNow", "reclassifyAcprOrganismes", "uploadAcprRegistre", "getAcprRegistreStats",
  "veilleMembreAnalyserDocument", "veilleMembreSubmit", "veilleMembreValider", "veilleMembreRejeter",
  "remerciementHebdoRun", "remerciementHebdoTest", "relancerCotisation", "remerciementCotisation",
  "envoyerAppelCotisation", "relanceAutoCotisationsTest", "saveRelanceCampagne", "adminEmailTemplateSave",
  "deleteRelanceCampagne", "previewRelanceCampagne", "launchRelanceCampagne", "datavizRelanceLaunch",
  "datavizSaisieGet", "datavizSaisieSubmit", "nootaListRecords", "nootaGetReport",
  "nootaGetTranscript", "nootaImportRecord", "nootaPreviewRecord", "getNootaImport",
  "analyserNootaCR", "deleteNootaImport", "detacherNootaImport", "updateNootaReport",
  "projetAnalyserDocument", "projetNootaApplierProposition", "socrate", "socrateJetonSpeech",
  "projetPropositionsLister",
]);

// Lot 4 (11/10/2026) : la connexion (functions/auth.js).
export const FONCTIONS_LOT4 = new Set([
  "aramisLoginCheck", "aramisSsoMicrosoftLogin", "passkeyChallenge", "passkeyLogin",
  "passkeyEnroler", "passkeyLister", "reinitDemander", "reinitInfoToken",
  "reinitFinaliser", "aramisVerifyTOTP", "aramisSetupTOTP", "aramisMigrateCredentials",
  "aramisStatutsComptes", "aramisStripDelegateCredentials", "authEnforcementLire", "authEnforcementDefinir",
  "aramisDefinirMotDePasse", "passkeyRetirer", "demandeCompteDeposer", "demandeCompteValider",
]);

const FONCTIONS_FRANCFORT = new Set([...FONCTIONS_EVENEMENTS, ...FONCTIONS_LOT1, ...FONCTIONS_LOT2, ...FONCTIONS_LOT3, ...FONCTIONS_LOT4]);
export const estAFrancfort = (nom) => FONCTIONS_FRANCFORT.has(nom);

export const regionFonction = (nom) => (FONCTIONS_FRANCFORT.has(nom) ? REGION_FRANCFORT : "us-central1");
